import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import css_248z from './quick-links.scss.js';

class QuickLinks extends s {
    render() {
        return $ `<div class="quick-links"><slot name="links-title"></slot><slot name="links"></slot></div>`;
    }
}
QuickLinks.styles = css_248z;
customElements.define('quick-links', QuickLinks);

export { QuickLinks };
